'use client';

import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/authStore';
import { getApiBaseUrl } from '@/utils/apiBaseUrl';
import { datadogUser } from '@/bootstrap/analyticsQueue';

// WHY: awaited before navigating: otherwise the RSC fetch for `/` carries the still-valid cookie and middleware bounces to
// /home
export function useLogout(): () => Promise<void> {
  const queryClient = useQueryClient();
  const markAnon = useAuthStore((s) => s.markAnon);

  return useCallback(async () => {
    try {
      await fetch(`${getApiBaseUrl()}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'X-Requested-With': 'shot' },
      });
    } catch {
    }
    markAnon();
    queryClient.clear();
    datadogUser.clear();
    if (typeof window !== 'undefined') {
      // WHY: @telegram-apps/sdk caches tgWebAppData in sessionStorage['tapps/launchParams']; uncleared, AuthBootstrap
      // re-logs the user in
      try { sessionStorage.removeItem('tapps/launchParams'); } catch { }
      window.location.replace('/');
    }
  }, [markAnon, queryClient]);
}
